module.exports = __webpack_public_path__ + "static/media/view.a6a2a955.svg";